import { ArticleHeading4, IconClose16 } from '@cian/ui-kit';
import * as classNames from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

interface IHeaderProps {
  title?: string;
  onClose(): void;
}

export const Header = ({ title, onClose }: IHeaderProps) => {
  return (
    <div className={classNames(styles['header'], title && styles['header_title'])}>
      {title && <ArticleHeading4>{title}</ArticleHeading4>}
      <IconClose16 onClick={onClose} />
    </div>
  );
};
